import { render, staticRenderFns } from "./contracts-list.vue?vue&type=template&id=431f2709&"
import script from "./contracts-list.vue?vue&type=script&lang=ts&"
export * from "./contracts-list.vue?vue&type=script&lang=ts&"
import style0 from "./contracts-list.vue?vue&type=style&index=0&id=431f2709&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports